import styled from 'styled-components'

import { Image as DefaultImage } from '../Image'

export const Image = styled(DefaultImage)`
	border-radius: ${({ size, isRounded }) => (isRounded ? size / 2 : null)}px;
`
